export default "__VITE_ASSET__CMbZkb5B__"